/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createMVPMetrics = /* GraphQL */ `mutation CreateMVPMetrics($input: CreateMVPMetricsInput!) {
  createMVPMetrics(input: $input) {
    mvp_id
    visitors
    savings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMVPMetricsMutationVariables,
  APITypes.CreateMVPMetricsMutation
>;
export const updateMVPMetrics = /* GraphQL */ `mutation UpdateMVPMetrics($input: UpdateMVPMetricsInput!) {
  updateMVPMetrics(input: $input) {
    mvp_id
    visitors
    savings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMVPMetricsMutationVariables,
  APITypes.UpdateMVPMetricsMutation
>;
export const deleteMVPMetrics = /* GraphQL */ `mutation DeleteMVPMetrics($input: DeleteMVPMetricsInput!) {
  deleteMVPMetrics(input: $input) {
    mvp_id
    visitors
    savings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMVPMetricsMutationVariables,
  APITypes.DeleteMVPMetricsMutation
>;
export const createCompanies = /* GraphQL */ `mutation CreateCompanies($input: CreateCompaniesInput!) {
  createCompanies(input: $input) {
    company_id
    company_type
    email
    headquarters
    name
    phone
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompaniesMutationVariables,
  APITypes.CreateCompaniesMutation
>;
export const updateCompanies = /* GraphQL */ `mutation UpdateCompanies($input: UpdateCompaniesInput!) {
  updateCompanies(input: $input) {
    company_id
    company_type
    email
    headquarters
    name
    phone
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompaniesMutationVariables,
  APITypes.UpdateCompaniesMutation
>;
export const deleteCompanies = /* GraphQL */ `mutation DeleteCompanies($input: DeleteCompaniesInput!) {
  deleteCompanies(input: $input) {
    company_id
    company_type
    email
    headquarters
    name
    phone
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompaniesMutationVariables,
  APITypes.DeleteCompaniesMutation
>;
export const createComplaints = /* GraphQL */ `mutation CreateComplaints($input: CreateComplaintsInput!) {
  createComplaints(input: $input) {
    company_type
    complaint_id
    complaint
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateComplaintsMutationVariables,
  APITypes.CreateComplaintsMutation
>;
export const updateComplaints = /* GraphQL */ `mutation UpdateComplaints($input: UpdateComplaintsInput!) {
  updateComplaints(input: $input) {
    company_type
    complaint_id
    complaint
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateComplaintsMutationVariables,
  APITypes.UpdateComplaintsMutation
>;
export const deleteComplaints = /* GraphQL */ `mutation DeleteComplaints($input: DeleteComplaintsInput!) {
  deleteComplaints(input: $input) {
    company_type
    complaint_id
    complaint
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteComplaintsMutationVariables,
  APITypes.DeleteComplaintsMutation
>;
export const createSubmissions = /* GraphQL */ `mutation CreateSubmissions($input: CreateSubmissionsInput!) {
  createSubmissions(input: $input) {
    submissionId
    company_id
    complaints
    name
    email
    phone
    dateOccurred
    generatedEmail
    timestamp
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubmissionsMutationVariables,
  APITypes.CreateSubmissionsMutation
>;
export const updateSubmissions = /* GraphQL */ `mutation UpdateSubmissions($input: UpdateSubmissionsInput!) {
  updateSubmissions(input: $input) {
    submissionId
    company_id
    complaints
    name
    email
    phone
    dateOccurred
    generatedEmail
    timestamp
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubmissionsMutationVariables,
  APITypes.UpdateSubmissionsMutation
>;
export const deleteSubmissions = /* GraphQL */ `mutation DeleteSubmissions($input: DeleteSubmissionsInput!) {
  deleteSubmissions(input: $input) {
    submissionId
    company_id
    complaints
    name
    email
    phone
    dateOccurred
    generatedEmail
    timestamp
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubmissionsMutationVariables,
  APITypes.DeleteSubmissionsMutation
>;
export const generateOpenAICompletion = /* GraphQL */ `mutation GenerateOpenAICompletion(
  $prompt: String!
  $recipientEmail: String
  $recipientName: String
) {
  generateOpenAICompletion(
    prompt: $prompt
    recipientEmail: $recipientEmail
    recipientName: $recipientName
  ) {
    text
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateOpenAICompletionMutationVariables,
  APITypes.GenerateOpenAICompletionMutation
>;
